import { render, staticRenderFns } from "./CMXmlDetails.vue?vue&type=template&id=700965a5&scoped=true&"
import script from "./CMXmlDetails.vue?vue&type=script&lang=js&"
export * from "./CMXmlDetails.vue?vue&type=script&lang=js&"
import style0 from "./CMXmlDetails.vue?vue&type=style&index=0&id=700965a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700965a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700965a5')) {
      api.createRecord('700965a5', component.options)
    } else {
      api.reload('700965a5', component.options)
    }
    module.hot.accept("./CMXmlDetails.vue?vue&type=template&id=700965a5&scoped=true&", function () {
      api.rerender('700965a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/payments/CMXmlDetails.vue"
export default component.exports